import { useSyncExternalStore } from 'react';

/**
 * Tracks whether the editor's native Drive Chooser miniapp is currently open
 * (via openDriveChooser → redirectToPackageId). Components subscribe to drop
 * their own stacking context to z-0 while the chooser is up, so its overlay
 * isn't fighting our z-indexes for foreground.
 */

let isOpen = false;
const listeners = new Set<() => void>();

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

function getSnapshot(): boolean {
  return isOpen;
}

export function setDriveChooserOpen(open: boolean): void {
  if (isOpen === open) return;
  isOpen = open;
  listeners.forEach(l => l());
}

export function useDriveChooserOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
